/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section2_P1Inputs */

const en_terms_section2_p1 = /** @type {(inputs: Terms_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON provides free, client-side JSON processing tools including but not limited to:`)
};

const ko_terms_section2_p1 = /** @type {(inputs: Terms_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 다음을 포함한 무료 클라이언트 사이드 JSON 처리 도구를 제공합니다:`)
};

const ja_terms_section2_p1 = /** @type {(inputs: Terms_Section2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONは以下を含む無料のクライアントサイドJSON処理ツールを提供します：`)
};

/**
* | output |
* | --- |
* | "PureJSON provides free, client-side JSON processing tools including but not limited to:" |
*
* @param {Terms_Section2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section2_p1 = /** @type {((inputs?: Terms_Section2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section2_p1(inputs)
	if (locale === "ko") return ko_terms_section2_p1(inputs)
	return ja_terms_section2_p1(inputs)
});